import component from './PhArrowsCounterClockwise.vue_vue_type_script_lang.vue.js';
export { default } from './PhArrowsCounterClockwise.vue_vue_type_script_lang.vue.js';
import { render } from './PhArrowsCounterClockwise.vue_vue_type_template_id_290963eb_lang.vue.js';

component.render = render;
